import {
  FETCHING_USER,
  SIGN_IN,
  SIGN_IN_MVPD,
  SIGN_OUT,
  PENDING_SIGN_OUT,
  UPDATE_USER_PROFILE,
  CLEAR_ENTITLEMENTS,
  UPDATE_ENTITLEMENTS,
} from '../Types';

export const initialUserState = {
  isAuthenticated: false, // non-anonymous user, identity account type
  isAnonymousUser: false,
  hasMvpd: false,
  mvpdId: '',
  profileId: null,
  userType: null,
  email: null,
  firstName: null,
  lastName: null,
  isFetching: false,
  entitlements: [],
  hasEntitlements: false,
  pendingSignOut: false,
};

export const user = (state = initialUserState, action) => {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        profileId: action.payload.profileId,
        userType: action.payload.userType,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        email: action.payload.email,
      };
    case SIGN_IN_MVPD:
      return {
        ...state,
        isAuthenticated: false,
        isAnonymousUser: true,
        hasMvpd: true,
        mvpdId: action.payload.mvpd,
      };

    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        profileId: undefined,
        userType: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        pendingSignOut: false,
      };
    case PENDING_SIGN_OUT:
      return {
        ...state,
        // used in RefreshTokenHandler as a flag to prevent multiple subsequent sign outs
        pendingSignOut: true,
      };

    case FETCHING_USER:
      return {
        ...state,
        isFetching: true,
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        email: action.payload.email,
        isFetching: false,
      };
    case UPDATE_ENTITLEMENTS:
      return { ...state, ...action.payload };
    case CLEAR_ENTITLEMENTS:
      return { ...state, entitlements: [], hasEntitlements: false };
    default:
      return state;
  }
};
